export default __webpack_public_path__ + "static/media/londres-3x.f7c93d0b.webp";